import React, { Component } from 'react';
import {Link, Redirect} from "react-router-dom";
import {CheckVal} from "./../../utils/functions";
import {ListWebsiteCustomJobs} from './../../utils/dbFunctions';
import BackButton from './../../components/backButton';

export default class AdminWebsiteCustomJobList extends Component {
  constructor(props) {
      super(props);
      this.state={
        items:[]
      };
  }
  componentDidMount = async() =>{
    let val = await CheckVal();
    let items = await ListWebsiteCustomJobs();
    this.setState({
      items:items
    })
  }
  render() {
    return (
      <div className="full-height full-width">
        <div className="admin-hero-padding primary-background-dark">
          <div className="small-padding">
            <BackButton />
            <div className="row" style={{marginBottom:"10px"}}>
              <div className="small-12 medium-10">
                <h2 className="white">{'Website Custom Jobs'}</h2>
                <p className="white subheading">{'Additional jobs not managed by greenhouse'}</p>
              </div>
              <div className="small-12 medium-2 row" style={{alignItems:'center'}}>
                <Link to={"/admin/job/add"}>
                  <div className="full-width button primary-color white-background">{'Add New'}</div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="small-padding">
          <div className="max-width-container" style={{marginLeft:0}}>
            {this.state.items && this.state.items.map((item) =>{
              let name = item.attributes.name;
              let department = item.attributes.department;
              let location = item.attributes.location;
              let opacity = item.attributes.status ? '1' : '.5';
              return(
                <Link to={'/admin/job/'+item.id}>
                  <div className="row small-margin-bottom border-bottom full-width" style={{opacity:opacity}}>
                    <div className="row" style={{alignItems:'center'}}>
                      <div>
                        {name && <h4>{name}</h4>}
                        {department && <p>{department}</p>}
                        {location && <p>{location}</p>}
                      </div>
                    </div>
                  </div>
                </Link>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}
